import { useRef, useState } from 'react';
import { IconName } from '@connect-x-app/shared-types';
import { ColorName, LAYERS } from '@connect-x-app/shared-ui';
import { partTestId } from '@connect-x-app/shared-utils';

import { Icon } from '../icon';
import { Tooltip } from '../tooltip';

import './IconWithTooltip.scss';

type Props = {
  colorName?: ColorName;
  iconName: IconName;
  label: string;
  size?: number;
  testId?: string;
};

export const IconWithTooltip = ({ colorName, iconName, label, size, testId }: Props) => {
  const [isHovered, setIsHovered] = useState(false);
  const iconRef = useRef(null);

  return (
    <div
      className="icon-with-tooltip"
      data-test={testId}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      ref={iconRef}
      role="presentation"
    >
      <Icon
        colorName={colorName}
        disabled
        hoverColorName={LAYERS.iconColors['$icon-accent']}
        name={iconName}
        size={size}
        testId={partTestId(testId, 'icon')}
      />
      {isHovered && (
        <Tooltip alignment="top" anchor={iconRef?.current} testId={partTestId(testId, 'tooltip')}>
          <slot name="content">{label}</slot>
        </Tooltip>
      )}
    </div>
  );
};
